const normalizePlayerId = (value) => {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number') return `${value}`;
  if (!value || typeof value !== 'object') return '';

  const candidate = value.id || value._id || value.playerId || value.player || value.value;
  if (candidate && candidate !== value) return normalizePlayerId(candidate);
  return '';
};

export const buildBowlerDropdownOptions = ({ bowlingPlayers = [], bowlerToHideForThisOver = '' } = {}) => {
  const hiddenBowlerId = normalizePlayerId(bowlerToHideForThisOver);
  if (!hiddenBowlerId) return Array.isArray(bowlingPlayers) ? bowlingPlayers : [];

  return (Array.isArray(bowlingPlayers) ? bowlingPlayers : [])
    .filter((player) => normalizePlayerId(player) !== hiddenBowlerId);
};
